/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {Error} from '../models/Error';
import type {LifeAgentSettings} from '../models/LifeAgentSettings';

export interface GetExceptDays$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getExceptDaysRequest = createAction<PayloadData<void>>('LIFE_AGENT__GET_EXCEPT_DAYS__REQUEST');
export const getExceptDaysSuccess = createAction<PayloadData<Array<string>>>('LIFE_AGENT__GET_EXCEPT_DAYS__SUCCESS');
export const getExceptDaysFailure = createAction<PayloadData<Error, void, true>>('LIFE_AGENT__GET_EXCEPT_DAYS__FAILURE');

export const getExceptDaysActions = [
    getExceptDaysRequest,
    getExceptDaysSuccess,
    getExceptDaysFailure
] as const;

/**
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getExceptDays = (config?: GetExceptDays$Config) => {
    return {
        CALL_API: {
            types: getExceptDaysActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/life-agent/except-days`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        }
    }
};

export interface GetLifeAgentSettings$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getLifeAgentSettingsRequest = createAction<PayloadData<void>>('LIFE_AGENT__GET_LIFE_AGENT_SETTINGS__REQUEST');
export const getLifeAgentSettingsSuccess = createAction<PayloadData<Array<LifeAgentSettings>>>('LIFE_AGENT__GET_LIFE_AGENT_SETTINGS__SUCCESS');
export const getLifeAgentSettingsFailure = createAction<PayloadData<Error, void, true>>('LIFE_AGENT__GET_LIFE_AGENT_SETTINGS__FAILURE');

export const getLifeAgentSettingsActions = [
    getLifeAgentSettingsRequest,
    getLifeAgentSettingsSuccess,
    getLifeAgentSettingsFailure
] as const;

/**
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getLifeAgentSettings = (config?: GetLifeAgentSettings$Config) => {
    return {
        CALL_API: {
            types: getLifeAgentSettingsActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/life-agent/settings`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        }
    }
};

export interface SaveExceptDays$Request {
    requestBody: Array<string>;
}

export interface SaveExceptDays$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const saveExceptDaysRequest = createAction<PayloadData<void, SaveExceptDays$Request>>('LIFE_AGENT__SAVE_EXCEPT_DAYS__REQUEST');
export const saveExceptDaysSuccess = createAction<PayloadData<void, SaveExceptDays$Request>>('LIFE_AGENT__SAVE_EXCEPT_DAYS__SUCCESS');
export const saveExceptDaysFailure = createAction<PayloadData<Error, SaveExceptDays$Request, true>>('LIFE_AGENT__SAVE_EXCEPT_DAYS__FAILURE');

export const saveExceptDaysActions = [
    saveExceptDaysRequest,
    saveExceptDaysSuccess,
    saveExceptDaysFailure
] as const;

/**
 * @param {Array<string>} meta.requestBody
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const saveExceptDays = (meta: SaveExceptDays$Request, config?: SaveExceptDays$Config) => {
    return {
        CALL_API: {
            types: saveExceptDaysActions,
            method: ApiMethods.PUT,
            endpoint: `/web-api/life-agent/except-days`,
            TRANSPORT_REQUEST_BODY: meta.requestBody,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface SaveLifeAgentSettings$Request {
    lifeAgentSettings: Array<LifeAgentSettings>;
}

export interface SaveLifeAgentSettings$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const saveLifeAgentSettingsRequest = createAction<PayloadData<void, SaveLifeAgentSettings$Request>>('LIFE_AGENT__SAVE_LIFE_AGENT_SETTINGS__REQUEST');
export const saveLifeAgentSettingsSuccess = createAction<PayloadData<void, SaveLifeAgentSettings$Request>>('LIFE_AGENT__SAVE_LIFE_AGENT_SETTINGS__SUCCESS');
export const saveLifeAgentSettingsFailure = createAction<PayloadData<Error, SaveLifeAgentSettings$Request, true>>('LIFE_AGENT__SAVE_LIFE_AGENT_SETTINGS__FAILURE');

export const saveLifeAgentSettingsActions = [
    saveLifeAgentSettingsRequest,
    saveLifeAgentSettingsSuccess,
    saveLifeAgentSettingsFailure
] as const;

/**
 * @param {Array<LifeAgentSettings>} meta.lifeAgentSettings
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const saveLifeAgentSettings = (meta: SaveLifeAgentSettings$Request, config?: SaveLifeAgentSettings$Config) => {
    return {
        CALL_API: {
            types: saveLifeAgentSettingsActions,
            method: ApiMethods.PUT,
            endpoint: `/web-api/life-agent/settings`,
            TRANSPORT_REQUEST_BODY: meta.lifeAgentSettings,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

